import { render, staticRenderFns } from "./ciSubscribers.vue?vue&type=template&id=1b4a3a8a&scoped=true"
import script from "./ciSubscribers.vue?vue&type=script&lang=js"
export * from "./ciSubscribers.vue?vue&type=script&lang=js"
import style0 from "./ciSubscribers.vue?vue&type=style&index=0&id=1b4a3a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a3a8a",
  null
  
)

export default component.exports